<template>
  <div class="info">
    <div class="left">
      <div class="logo">
        <img :src="`${info.logo || `${publicPath}img/picture/logo.png`}`" alt />
      </div>
      <span>{{ info.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    info() {
      return this.$store.state.auth.baseInfo;
    },
  },
  methods: {},

  mounted() {},
};
</script>

<style lang="less" scoped>
.info {
  height: 232px;
  .left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .logo {
      width: 180px;
      height: 90px;
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    span {
      font-size: 30px;
      color: #5d6067;
    }
  }
}
</style>
